import { Config } from '../../config'

export const midlandConfig: Config = {
  partner: 'midland',
  catalog: 'partner',
  displayName: 'Midland',
  accentColor: '#405694',
  host: 'catalog.midlandsci.com',
}

